import { ATV_PRODUCT_NAME, MC_SITE_NAME, SXS_PRODUCT_NAME } from '../constants';

const productLineFromVehicleType = new Map();

productLineFromVehicleType.set('ON-ROAD', MC_SITE_NAME);
productLineFromVehicleType.set('OFF-ROAD', MC_SITE_NAME);
productLineFromVehicleType.set(ATV_PRODUCT_NAME, ATV_PRODUCT_NAME);
productLineFromVehicleType.set(SXS_PRODUCT_NAME, SXS_PRODUCT_NAME);

export default productLineFromVehicleType;
